export default [
    {
        "titleId": "singleGame",
        "title": "Single Game",
        "tooltip": "Play select individual games without saving data.",
        "view": "/play_game?single_game_id=ALL",
        "icon_data": {
            "path": "single-game.svg"
        },        
        "color": "#f04c58",
        "is_external": true,
        "bottom_title": true,
        "border_radius": "40px 7px 40px 7px",
        "limited": true,
        "card_class": "red"
    },
    {
        "titleId": "restoreTogether",
        "title": "Restore Together",
        "tooltip": "Play games with others in real time",
        "view": "restore-together",
        "icon_data": {
            "path": "quick-session.svg"
        },
        "color": "#76c15d",
        "is_external": false,
        "bottom_title": true,
        "limited": true,
        "border_radius": "7px 40px 7px 40px",
        "card_class": "green"
    },
    {
        "titleId": "groupPlay",
        "title": "Group Play",
        "tooltip": "Play select games with up to 6 patients at a time, through turn-taking without saving data. ",
        "view": "/play_game?group_play_id=1",
        "icon_data": {
            "path": "group-play.svg"
        },
        "color": "#0a9ecc",
        "is_external": true,
        "limited": true,
        "bottom_title": false,
        "border_radius": "7px 40px 7px 40px",
        "card_class": "blue",
    },
    {
        "titleId": "designedSession",
        "title": "Designed Session",
        "tooltip": "Select sets of games designed by RESTORE's therapists, from your own, or create individual ones for specific patients, to track data and progress for specific players.",
        "view": "therapistDashboard",
        "icon_data": {
            "path": "designed-session.svg"
        },
        "color": "#eaab4e",
        "is_external": false,
        "limited": false,
        "bottom_title": false,
        "border_radius": "40px 7px 40px 7px",
        "card_class": "yellow"
    }
]


// WEBPACK FOOTER //
// ./src/components/containers/play-screen/button-config-functional-skill-view.js